module.exports = "/assets/data/75afc7bdb1bf1768ed5d3e9c62ebbbe9-NW8.data.json";